import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext();

const COUNTRY_CURRENCY_MAP = {
  GH: "GHS",
  US: "USD",
  GB: "GBP",
};

const CURRENCY_SYMBOLS = {
  GHS: "GHS",
  USD: "$",
  GBP: "£",
  EUR: "€",
};

const DEFAULT_CURRENCY = "GHS";

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function detectCurrency() {
      try {
        const res = await fetch("https://ipapi.co/json/");
        if (!res.ok) throw new Error("Geo lookup failed");
        const data = await res.json();
        const resolved = COUNTRY_CURRENCY_MAP[data?.country_code] || "EUR";
        if (isMounted) setCurrency(resolved);
      } catch (err) {
        console.warn(
          "Currency detection failed, defaulting to",
          DEFAULT_CURRENCY,
          err,
        );
        if (isMounted) setCurrency(DEFAULT_CURRENCY);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    detectCurrency();
    return () => {
      isMounted = false;
    };
  }, []);

  const getPrice = (item) => {
    const amount =
      item.prices?.[currency] ?? item.prices?.[DEFAULT_CURRENCY] ?? 0;
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    return currency === "GHS" ? `GHS ${amount}` : `${symbol}${amount}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, loading, getPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx)
    throw new Error("useCurrency must be used within a CurrencyProvider");
  return ctx;
}
